import PropTypes from 'prop-types';
import FJSwitchButton from '../../../common/components/FJSwitchButton/FJSwitchButton';
import styles from './FJImageEnhancerCard.module.less';
import FJLocalStore from '../../../store/FJLocalStore';
import classNames from 'classnames';
import { useEffect, useRef } from 'react';
import FJUtil from '../../../util/FJUtil';
import { IMAGE_ENHANCER_POINT_COUNT } from '../../../config/dataConfig/FJImageManipulationData';
import { useState } from 'react';

const percentStyles = progress => {
    return progress * 100 + '%';
};
const percentHandleStylesStyles = progress => {
    //对齐handle
    if (progress < 1 / 2 && progress > 0) {
        return (progress - 0.01) * 100 + '%';
    } else if (progress > 1 / 2 && progress < 1) {
        return (progress + 0.01) * 100 + '%';
    } else {
        return progress * 100 + '%';
    }
};
const _percentToUpscale = prc => {
    if (prc < 1 / 6) {
        return 1;
    } else if (prc < 3 / 6) {
        return 2;
    } else if (prc < 5 / 6) {
        return 3;
    } else return 4;
};
const _upscaleToPercent = value => {
    // if (prc < 1 / 6) {
    //     return 1;
    // } else if (prc < 3 / 6) {
    //     return 2;
    // } else if (prc < 5 / 6) {
    //     return 3;
    // } else return 4;

    switch (value) {
        case 1:
            return 0;
        case 2:
            return 2 / 6;
        case 3:
            return 4 / 6;
        case 4:
            return 1;
        default:
            return 1;
    }
};

const FJImageEnhancerCard = props => {
    const {
        uploadImageInfo = {},
        onSwitch,
        onChangeZoom,
        // onChangeImageType,
        // imageType,
        active,
        upscale,
        isSingle = false,
        disabled,
        style,
    } = props;
    const { src: imgSrc, width, height } = uploadImageInfo;
    const sliderContainerRef = useRef(null);
    const handleRef = useRef(null);
    const [percent, setPercent] = useState(_upscaleToPercent(upscale));

    useEffect(() => {
        setPercent(_upscaleToPercent(upscale));
    }, [upscale]);

    /**
     * @description 渲染刻度线
     * @returns {*[]}
     * @private
     */
    const _renderLine = () => {
        let listComp = [];
        const lineSum = IMAGE_ENHANCER_POINT_COUNT;
        for (let i = 0; i < lineSum; i++) {
            let lineStyle = {};
            const progress = (1 / (lineSum - 1)) * i;
            lineStyle.left = percentStyles(progress);
            if (progress > 0) {
                lineStyle.marginLeft = '-1px';
            }
            const value = i + 1;
            const isHideLine = i === 0 || i === lineSum - 1;
            lineStyle.width = isHideLine ? '0' : 2;
            listComp.push(
                <div key={i} className={styles.line} style={lineStyle}>
                    <div className={classNames(styles[`line_value_${i}`], styles.line_value)}>{value}x</div>
                </div>,
            );
        }
        return listComp;
    };

    /**
     * @description 鼠标位置切换为progress
     * @param e
     * @returns {*}
     * @private
     */
    const _convertToProgress = e => {
        if (!sliderContainerRef.current) {
            return;
        }
        let point = {
            left: e.clientX,
            top: e.clientY,
        };
        let rect = sliderContainerRef.current.getBoundingClientRect();

        let value = 0;
        let progress = 0;
        value = point.left - rect.left;
        value = FJUtil.getValueInRange(value, 0, rect.width);
        progress = Math.round((value / rect.width) * 100) / 100;
        return progress;
    };

    const _onMouseMove = e => {
        const prc = _convertToProgress(e);
        setPercent(prc);
        // const zoom = _percentToUpscale(prc);
        // onChangeZoom(zoom);
    };
    const _adsorption = number => {
        if (number < 1 / 6) {
            return 0;
        } else if (number < 3 / 6) {
            return 2 / 6;
        } else if (number < 5 / 6) {
            return 4 / 6;
        } else return 1;
    };
    const _moveThrottle = FJUtil.throttle(_onMouseMove, 20);
    /**
     * @description 鼠标按下
     * @param e
     * @private
     */
    const _onMouseDown = e => {
        const prc = _convertToProgress(e);
        setPercent(prc);
        const zoom = _percentToUpscale(prc);
        onChangeZoom(zoom);
        handleRef.current.style.transition = 'none';
        FJUtil.addEvent(window, 'mousemove', _moveThrottle);
        FJUtil.addEvent(window, 'mouseup', _onMouseUp);
    };

    const _onMouseUp = e => {
        const prc = _convertToProgress(e);
        setPercent(prc);
        const zoom = _percentToUpscale(prc);
        onChangeZoom(zoom);
        setTimeout(() => {
            // 延迟动画效果
            handleRef.current.style.transition = 'all 0.1s';
            setPercent(_adsorption(prc));
        }, 50);

        FJUtil.removeEvent(window, 'mousemove', _moveThrottle);
        FJUtil.removeEvent(window, 'mouseup', _onMouseUp);
    };
    let trackStyles = { width: percentStyles(percent) };
    let handleStyles = { left: percentHandleStylesStyles(percent) };
    const sliderInfo = imgSrc
        ? `${Math.floor(width)} * ${Math.floor(height)} > ${Math.floor(width * upscale)} * ${Math.floor(height * upscale)} px`
        : '';

    return (
        <div
            className={classNames(
                styles.card,
                active && styles.active,
                isSingle && styles.single,
                disabled && styles.disabled,
            )}
            style={style}
        >
            <div className={styles.header} style={{ marginBottom: isSingle ? 12 : 0 }}>
                <div className={styles.header_text}>
                    {isSingle ? FJLocalStore._('upscale-size') : FJLocalStore._('ai-image-upscaler')}
                </div>
                <FJSwitchButton className={styles.switch_btn} active={active} onChange={onSwitch} />
            </div>
            {active && (
                <>
                    {!isSingle && (
                        <div className={styles.slider_header}>
                            <div className={styles.slider_title}>{FJLocalStore._('upscale-size')}</div>
                            <div className={styles.slider_info}>{sliderInfo}</div>
                        </div>
                    )}
                    <div className={styles.slider_box} onMouseDown={_onMouseDown} ref={sliderContainerRef}>
                        <div className={styles.rail} />
                        <div className={styles.track} style={trackStyles} />
                        {_renderLine()}
                        <div className={styles.handle_box}>
                            <div ref={handleRef} className={styles.handle} style={handleStyles} />
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};
FJImageEnhancerCard.propTypes = {
    imageEnhancerData: PropTypes.object,
    uploadImageInfo: PropTypes.object,
    onSwitch: PropTypes.func,
    onChangeZoom: PropTypes.func,
    onChangeImageType: PropTypes.func,
    active: PropTypes.bool,
    progress: PropTypes.number,
    isSingle: PropTypes.bool,
    imageType: PropTypes.string,
    disabled: PropTypes.bool,
    style: PropTypes.object,
    upscale: PropTypes.number,
};

export default FJImageEnhancerCard;
